function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M78.7,36.4l5.2-6.2c0.5-0.6,0.4-1.5-0.2-2l-4.2-3.5c-0.6-0.5-1.5-0.4-2,0.2l-4.8,5.7c-4-2.9-8.7-4.9-13.8-5.6V20h6.1 c0.7,0,1.2-0.6,1.2-1.2V14c0-0.7-0.6-1.2-1.2-1.2H44.5c-0.7,0-1.2,0.6-1.2,1.2v4.8c0,0.7,0.6,1.2,1.2,1.2h6.1v5.1 c-5.1,0.7-9.8,2.6-13.8,5.6l-4.8-5.7c-0.5-0.6-1.4-0.7-2-0.2l-4.2,3.5c-0.6,0.5-0.7,1.4-0.2,2l5.1,6.1c-1.7,2.1-3.1,4.4-4.2,7 c-0.5,1.3,0.1,2.7,1.3,3.2c1.3,0.5,2.7-0.1,3.2-1.3c4-9.5,13.2-15.6,23.5-15.6c14.1,0,25.5,11.4,25.5,25.5 c0,14.1-11.4,25.5-25.5,25.5c-4.1,0-8-0.9-11.7-2.8c-1.2-0.6-2.7-0.1-3.3,1.1s-0.1,2.7,1.1,3.3c4.3,2.2,9.1,3.4,13.9,3.4 c16.8,0,30.4-13.7,30.4-30.4C85.2,48.1,82.8,41.6,78.7,36.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60,56.2c8.3-9.9,8.8-12.8,8.3-13.3c-0.6-0.6-3.4-0.1-13.3,8.3c-4.7,4-3.2,6.2-2.2,7.3C53.8,59.4,56.1,60.9,60,56.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40,52.5c0-1.2-0.9-2.1-2.1-2.1H13c-1.2,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1h24.8C39,54.6,40,53.6,40,52.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.9,61H23.5c-1.2,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1h14.4c1.2,0,2.1-0.9,2.1-2.1S39,61,37.9,61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.9,71.8H17.1c-1.2,0-2.1,0.9-2.1,2.1c0,1.2,0.9,2.1,2.1,2.1h20.7C39,76,40,75,40,73.9C40,72.7,39,71.8,37.9,71.8z"
}));

function SvgClocknew2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClocknew2);
export default __webpack_public_path__ + "static/media/clocknew2.f528199c.svg";
export { ForwardRef as ReactComponent };